export const EXPAND_DEFAULT_MAX_CHARS = 20_000;
export const EXPAND_MAX_CHARS = 24_000;
export const EXPAND_DEFAULT_MAX_ENTRIES = 10;
export const EXPAND_MAX_ENTRIES = 20;
export const EXPAND_MAX_CONTEXT = 100;
export const EXPAND_MAX_EXACT_SELECTORS = 100;
export const SESSIONS_MAX = 500;
